import { DatePipe } from '@angular/common';
import { Component, input, ViewChild } from '@angular/core';
import { SECDocumentViewerComponent } from '../sec-document-viewer/sec-document-viewer.component';

@Component({
  selector: 'sec-documents-block',
  imports: [
    DatePipe,
    SECDocumentViewerComponent,
  ],
  templateUrl: './sec-documents-block.component.html',
  styleUrl: './sec-documents-block.component.scss'
})
export class SecDocumentsBlockComponent {
    readonly documents = input<any[]>([])
    readonly colsDefn = input<string>("col-lg-12 col-xl-6")

    @ViewChild(SECDocumentViewerComponent) secViewerComponent: SECDocumentViewerComponent | undefined

    public openDocument(document: any) {
        this.secViewerComponent!.displayDocumentViaFormIDAndDocID(document.form_id, document.document_id)
    }
}
